import Header from './components/header/header';
import Footer from './components/footer/footer';
import Hero from './components/sections/hero/hero';
import About from './components/sections/about/about';
import Skills from './components/sections/skills/skills';
import Project from './components/sections/project/project';
import Contact from './components/sections/contact/contact';
import styles from './LandingPage.module.scss';

function LandingPage() {
  return (
    <div className={styles["container"]}>
      <Header />
      <main className={styles["main"]}>
        <Hero />
        <About />
        <Skills />
        <Project />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;
